import React, { FC } from 'react'
import { Tab, Tabs } from '@material-ui/core'

type DatasetTableTabsProps = {
  tabs: string[]
  value: number
  setValue: (value: number) => void
}

export const DatasetTableTabs: FC<DatasetTableTabsProps> = ({ tabs, value, setValue }) => {
  return (
    <Tabs
      value={value}
      onChange={(e, numb) => setValue(numb)}
      aria-label="Select dataset tabs"
      textColor="primary"
      indicatorColor="primary"
      style={{ borderBottom: '1px solid rgb(229, 229, 229)' }}>
      {tabs.map(tab => (
        <Tab key={tab} label={tab} />
      ))}
    </Tabs>
  )
}
